<template>
    <productsComp />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue'

const productsComp = defineAsyncComponent(() => import('@/components/managementPages/productsPage/productComp.vue'))
</script>